export default "__VITE_ASSET__3860a3e6__"